module.exports = "https://coursera_assets.s3.amazonaws.com/images/912f3c7840885333d9e72aaa886a1c9b.png";